import { render, staticRenderFns } from "./NavigationMenuPromoMediaItem.vue?vue&type=template&id=63526f9c"
import script from "./NavigationMenuPromoMediaItem.vue?vue&type=script&lang=js"
export * from "./NavigationMenuPromoMediaItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuPromoMediaItem.vue?vue&type=style&index=0&id=63526f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports